import CardHeader from "@/components/Includes/CardHeader/CardHeader.vue";
import DefaultTools from '@/components/Includes/DefaultTools/DefaultTools.vue';
import Loader from '@/components/Includes/Loader/Loader.vue';
import Pagination from '@/components/Includes/Pagination/Pagination.vue';
import TableEmpty from '@/components/Includes/Table/TableFooter/TableEmpty/TableEmpty.vue';
import dateToStandart from "@/libs/date/dateToStandart";

import IMeditationCategory from "@/interfaces/astrology/meditation/meditationCategory/IMeditationCategory";
import IMeditationResource from "@/interfaces/astrology/meditation/meditationResource/IMeditationResource";
import IPayloadQuery from '@/interfaces/IPayloadQuery';
import ITableCol from "@/interfaces/ITableCol";
import IMultiSelectItem from "@/interfaces/selects/IMultiSelectItem";

import cleanData from "@/libs/cleanData";
import cloneObject from "@/libs/cloneObject";
import getParamQuery from "@/libs/getParamQuery";
import getQueryData from "@/libs/getQueryData";
import getTableColumns from "@/libs/getTableColumns";
import isEmpty from "@/libs/isEmpty";
import searchByTable from "@/libs/searchQuery/searchByTable";
import urlToId from '@/libs/urlToId';

import Multiselect from 'vue-multiselect';
import {Component, Vue, Watch} from 'vue-property-decorator';
import {Action, Getter} from 'vuex-class';

import MeditationRecourceCreate from '../MeditationRecourceCreate/MeditationRecourceCreate.vue';
import MeditationRecourceDetail from '../MeditationRecourceDetail/MeditationRecourceDetail.vue';

@Component({
    name: 'MeditationRecourcesList',
    components: {
        CardHeader,
        DefaultTools,
        Loader,
        Pagination,
        TableEmpty,
        MeditationRecourceCreate,
        MeditationRecourceDetail,
        Multiselect
    }
})
export default class MeditationRecourcesList extends Vue {

    // Begin Vuex Logic for Meditation Resouces
    @Action private meditationResourcesList!: (query: IPayloadQuery) => number;
    @Getter private getMeditationResources!: () => IMeditationResource[];
    // End Vuex Logic for Meditation Resouces

    // Begin Vuex Logic for Meditation Categories
    @Action private meditationCategoriesList!: (query: IPayloadQuery) => Promise<void>;
    @Getter private getMeditationCategories!: () => IMeditationCategory[];
    // End Vuex Logic for Meditation Categories

    private loading: boolean = true;

    private createMeditationResourceForm: boolean = false;
    private detailMeditationResourceForm: boolean = false;

    private meditationCategories: IMultiSelectItem[] = [];
    private meditaionResources: IMeditationResource[] = [];

    private selectedMeditationResource: IMeditationResource | null = null;

    private filtered: any = null;

    private selectedTableColumns: IMultiSelectItem[] = [];

    // Begin Config for Pagination
    private totalMeditationResources: number | void | null = null;
    private currentPage: number = 1;
    private selectedLimit: string = '100';
    // End Config for Pagination


    // Begin Config for Table
    private showModalDetail(meditationResourse: IMeditationResource) {
        this.detailMeditationResourceForm = !this.detailMeditationResourceForm;
        this.selectedMeditationResource = cloneObject(meditationResourse);

        if (this.selectedMeditationResource) {
            const {category} = this.selectedMeditationResource;
            const normalizeSelectedCategory = this.getCategory(category);
            this.selectedMeditationResource.category = {
                value: category,
                label: normalizeSelectedCategory.name
            };
        }
    }

    private hideModalDetail() {
        this.detailMeditationResourceForm = false;
        this.selectedMeditationResource = null;
    }

    private showModalCreate() {
        this.createMeditationResourceForm = !this.createMeditationResourceForm
    }

    private hideModalCreate() {
        this.createMeditationResourceForm = false;
    }

    private filterData(query: string) { // Method for search tool
        this.filtered = searchByTable(query, this.meditaionResources)
    }

    private get tableItems(): IMeditationResource[] {
        return this.filtered ? this.formattedDates(this.filtered) : this.formattedDates(this.meditaionResources);
    }

    private formattedDates(data: IMeditationResource[]) {
        return data.map(el => {
            return {
                ...el,
                ...(el.createdAt && {createdAt: dateToStandart(el.createdAt)}),
                ...(el.updatedAt && {updatedAt: dateToStandart(el.updatedAt)})
            }
        })
    }

    private get tableColumns(): ITableCol[] | undefined {
        if (this.tableItems) {
            return getTableColumns(this.meditaionResources, true, ['id']);
        }
    };

    private get fields() {
        if (this.tableColumns) {
            const columnsIds = this.selectedTableColumns.map((el: IMultiSelectItem) => el.value);
            return this.tableColumns.filter((el: any) => columnsIds.includes(el.key));
        } else {
            return this.tableColumns;
        }
    }

    // End Config for Table

    // Begin Query Logic
    private get payloadQuery(): IPayloadQuery {
        return {
            ...getParamQuery(this.$route),
            metaData: true
        }
    }

    private get normalizedMeditationCategories() {
        return this.getMeditationCategories().reduce((acc: {[key: string]: IMeditationCategory}, item) => {
            if (item.id) {
                acc[item.id] = item;
            }
            return acc;
        }, {})
    }

    private queryValue() {
        if (this.payloadQuery.query && this.payloadQuery.query.length > 0) {
            this.readQueryValue();
        } else {
            this.writeQueryValue();
            this.readQueryValue();
        }
    }

    private readQueryValue() {
        const queryData = getQueryData(this.$route.query);

        queryData.map(({key, value}) => {
            switch (key) {
                case 'page': {
                    this.currentPage = value;
                    break;
                }
                case 'limit': {
                    this.selectedLimit = value;
                    break;
                }
                default:
                    break;
            }
        });
    }

    @Watch('selectedLimit')
    @Watch('currentPage')
    private writeQueryValue() {
        const queryData: any = {
            page: this.currentPage,
            limit: this.selectedLimit
        };

        this.$router.replace({
            name: this.$route.name || undefined,
            query: cleanData(queryData)
        });
    }

    // End Query Logic

    @Watch('selectedLimit')
    @Watch('currentPage')
    private async getMeditationResourcesList() {
        try {
            this.loading = true;
            this.queryValue();

            this.totalMeditationResources = await this.meditationResourcesList(this.payloadQuery);
            this.meditaionResources = this.getMeditationResources();

            this.loading = false;

        } catch (error) {
            throw new Error(error);
        }
    }

    private async getRelations() {
        this.meditationCategories = this.transformSelectValues();
        if (isEmpty(this.getMeditationCategories())) {
            await this.meditationCategoriesList({query: '?pagination=false&limit=300'});
            this.meditationCategories = this.transformSelectValues();
        }
    }

    private transformSelectValues() {
        return this.getMeditationCategories().map((el) => {
            return {
                value: `/api/astrology/meditation_categories/${el.id}`,
                label: el.name
            }
        });
    }

    private getCategory(categoryUrl: string) {
        const id = urlToId(categoryUrl);
        
        // @ts-ignore
        return this.normalizedMeditationCategories[id] || {id: 0, name: ''};
    }

    private async mounted() {
        try {
            await this.getRelations();
            await this.getMeditationResourcesList();
        } catch (error) {
            throw new Error(error);
        }
    }
}
